var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Schema, type } from "@colyseus/schema";
/** A synced bag of the four resource types. */
export class ResourceBag extends Schema {
    constructor() {
        super(...arguments);
        this.minerals = 0;
        this.food = 0;
        this.vigor = 0;
        this.obsidian = 0;
    }
}
__decorate([
    type("uint16")
], ResourceBag.prototype, "minerals", void 0);
__decorate([
    type("uint16")
], ResourceBag.prototype, "food", void 0);
__decorate([
    type("uint16")
], ResourceBag.prototype, "vigor", void 0);
__decorate([
    type("uint16")
], ResourceBag.prototype, "obsidian", void 0);
//# sourceMappingURL=ResourceBag.js.map